import axios from "axios";
import { notConnectedMessage } from "../../components/constants";
import { IOrgadmin } from "../../components/UserContext";
import { BASE_API } from "../../utils/constants";
import { Api_Response, GET, POST } from "../base-services";

export interface INew_Admin {
    name: string;
    username: string;
    password: string;
    orgId: string;
    // address: string;
}

export class Admin_Service {
    static url = "/admin";

    static async login_admin(
        creds: { username: string; password: string },
        org_code: string
    ) {
        return POST<Login_Admin_Response>(
            `${Admin_Service.url}/login`,
            creds,
            {},
            { "x-org": org_code }
        );
    }

    static async is_logged() {
        return GET<Is_Logged_Response>(`${Admin_Service.url}/is-logged`);
    }

    static async logout() {
        return POST<Logout_Response>(`${Admin_Service.url}/logout`);
    }

    static async createAdmin(admin: INew_Admin) {
        try {
            const response = await axios.post(`${BASE_API}` + this.url, admin, {
                withCredentials: true,
            });

            return [response.data, null];
        } catch (err: any) {
            console.log(err.response);

            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async getAdmins(page = 1, limit = 20, filter = {}) {
        try {
            const response = await axios.get(`${BASE_API}` + this.url, {
                withCredentials: true,
                params: { page, limit, ...filter },
            });
            return [response.data, null];
        } catch (err: any) {
            console.log(err.response);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async editAdmin(username: number, data: INew_Admin) {
        try {
            const response = await axios.patch(`${BASE_API}` + this.url, data, {
                params: { username: username },
                withCredentials: true,
            });

            return [response.data, null];
        } catch (error: any) {
            console.log(error);

            return [
                null,
                error.response?.data?.messaggeg || notConnectedMessage,
            ];
        }
    }

    static async deleteAdmin(username: number) {
        try {
            const response = await axios.delete(`${BASE_API}` + this.url, {
                params: { username: username },
                withCredentials: true,
            });

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }
}

type Login_Admin_Response = Api_Response<{ message: string; admin: IOrgadmin }>;
type Is_Logged_Response = Api_Response<{ message: string; admin: IOrgadmin }>;
type Logout_Response = Api_Response<{ message: string }>;
